import { render, staticRenderFns } from "./CouponPop.vue?vue&type=template&id=cc35f592&scoped=true&"
import script from "./CouponPop.vue?vue&type=script&lang=js&"
export * from "./CouponPop.vue?vue&type=script&lang=js&"
import style0 from "./CouponPop.vue?vue&type=style&index=0&id=cc35f592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc35f592",
  null
  
)

export default component.exports